import React from 'react'
// import { Link } from 'react-router-dom'
export default function ProjectTemplate(props) {
    const Css= {
        "--background":`${props.isValue ? props.mode : 'red'}`
    }    
    return (
        <>
            <div className="bodyCon projectCon">
                <div className="bodyComponent">
                    <div className="aboutHeading projectHeading" style={Css}>
                        <h1>{props.name}</h1>
                        <div className="container">
                            <div className="projects">
                                {props.children}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
